export const ResultsMockData = [
    {
        position: "1",
        horseNumber: "8",
        horseName: "TWIN PEAKS",
        trainerName: "Sean Tarry",
        jockeyName: "L Hewitson",
        equipment: "A",
        weight: "60kg",
        draw: "3",
        openingPrice: {
            numerator: '8',
            denominator: '1'
        },
        startingPrice: {
            numerator: '13',
            denominator: '1'
        },
        length: 0,
        time: "73.1",
        meritRating: 0
    },
    {
        position: "2",
        horseNumber: "2",
        horseName: "Justin Snaith",
        trainerName: "Justin Snaith",
        jockeyName: "A Marcus",
        equipment: "A",
        weight: "60kg",
        draw: "3",
        openingPrice: {
            numerator: '8',
            denominator: '1'
        },
        startingPrice: {
            numerator: '13',
            denominator: '1'
        },
        length: 0,
        time: "73.1",
        meritRating: 0
    },
    {
        position: "3",
        horseNumber: "5",
        horseName: "Mike de Kock",
        trainerName: "Mike de Kock",
        jockeyName: "R Munger",
        equipment: "A",
        weight: "60kg",
        draw: "3",
        openingPrice: {
            numerator: '8',
            denominator: '1'
        },
        startingPrice: {
            numerator: '13',
            denominator: '1'
        },
        length: 0,
        time: "73.1",
        meritRating: 0
    },
    {
        position: "4",
        horseNumber: "9",
        horseName: "Alan Greeff",
        trainerName: "Alan Greeff",
        jockeyName: "R Fourie",
        equipment: "A",
        weight: "60kg",
        draw: "3",
        openingPrice: {
            numerator: '8',
            denominator: '1'
        },
        startingPrice: {
            numerator: '13',
            denominator: '1'
        },
        length: 0,
        time: "73.1",
        meritRating: 0
    },
    {
        position: "5",
        horseNumber: "10",
        horseName: "Brett Crawford",
        trainerName: "Brett Crawford",
        jockeyName: "G Cheyne",
        equipment: "A",
        weight: "60kg",
        draw: "3",
        openingPrice: {
            numerator: '8',
            denominator: '1'
        },
        startingPrice: {
            numerator: '13',
            denominator: '1'
        },
        length: 0,
        time: "73.1",
        meritRating: 0
    },
    {
        position: "6",
        horseNumber: "1",
        horseName: "Candice Bass-Robinson",
        trainerName: "Candice Bass-Robinson",
        jockeyName: "Tara Laing",
        equipment: "A",
        weight: "60kg",
        draw: "3",
        openingPrice: {
            numerator: '8',
            denominator: '1'
        },
        startingPrice: {
            numerator: '13',
            denominator: '1'
        },
        length: 0,
        time: "73.1",
        meritRating: 0
    },
    {
        position: "7",
        horseNumber: "2",
        horseName: "Yvette Bremner",
        trainerName: "Yvette Bremner",
        jockeyName: "W Kennedy",
        equipment: "A",
        weight: "60kg",
        draw: "3",
        openingPrice: {
            numerator: '8',
            denominator: '1'
        },
        startingPrice: {
            numerator: '13',
            denominator: '1'
        },
        length: 0,
        time: "73.1",
        meritRating: 0
    },
    {
        position: "8",
        horseNumber: "4",
        horseName: "Andre Nel",
        trainerName: "Andre Nel",
        jockeyName: "G Lerena",
        equipment: "A",
        weight: "60kg",
        draw: "3",
        openingPrice: {
            numerator: '8',
            denominator: '1'
        },
        startingPrice: {
            numerator: '13',
            denominator: '1'
        },
        length: 0,
        time: "73.1",
        meritRating: 0
    },
    {
        position: "9",
        horseNumber: "11",
        horseName: "Paul Peter",
        trainerName: "Paul Peter",
        jockeyName: "L J Ferraris",
        equipment: "A",
        weight: "60kg",
        draw: "3",
        openingPrice: {
            numerator: '8',
            denominator: '1'
        },
        startingPrice: {
            numerator: '13',
            denominator: '1'
        },
        length: 0,
        time: "73.1",
        meritRating: 0
    },
    {
        position: "10",
        horseNumber: "12",
        horseName: "St John Gray",
        trainerName: "St John Gray",
        jockeyName: "A Domeyer",
        equipment: "A",
        weight: "60kg",
        draw: "3",
        openingPrice: {
            numerator: '8',
            denominator: '1'
        },
        startingPrice: {
            numerator: '13',
            denominator: '1'
        },
        length: 0,
        time: "73.1",
        meritRating: 0
    },
    {
        position: "11",
        horseNumber: "6",
        horseName: "J A Janse van Vuuren",
        trainerName: "J A Janse van Vuuren",
        jockeyName: "B Lerena",
        equipment: "A",
        weight: "60kg",
        draw: "3",
        openingPrice: {
            numerator: '8',
            denominator: '1'
        },
        startingPrice: {
            numerator: '13',
            denominator: '1'
        },
        length: 0,
        time: "73.1",
        meritRating: 0
    },
    {
        position: "12",
        horseNumber: "5",
        horseName: "Gavin Smith",
        trainerName: "Gavin Smith",
        jockeyName: "A Delpesh",
        equipment: "A",
        weight: "60kg",
        draw: "3",
        openingPrice: {
            numerator: '8',
            denominator: '1'
        },
        startingPrice: {
            numerator: '13',
            denominator: '1'
        },
        length: 0,
        time: "73.1",
        meritRating: 0
    }
];